import React from 'react';
import moment from 'moment';
import { Tooltip } from 'reactstrap';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { getColor } from '../common/colors';
import { popupActions } from '../../store/popupStore';
import { hasPermission } from '../../store/apiWrapper';
import { REPORTS, SECTIONS, reportActions } from '../../store/reportStore';
import { SemaphoreGroup } from '../common/semaphors';
import { redirectToRepi } from '../common/reportLinks';
import { getRepiSetting, isNullOrUndefined, isString } from '../../store/storeFunctions';
import BbPopover from '../common/popover';
import RatingCard from './rating/ratingCard';
import RatingTable from './rating/ratingTable';
import PaymentChart from './rating/paymentChart';
import IndexHistory from './rating/indexHistory';
import FinStatement from './rating/financialStatement';
import SemaphoreHistory from './rating/semaphoreHistory';
import TopStableCompanyBadge from '../../img/stableCompanyBadge.svg';
import StableCompanyBadge from '../../img/topStableCompanyBadge.svg';

import MarkIcon from '../../img/icons/BBicons_Zalozka';

import './rating/rating.scss';

const imagesBw = [
    { ci: 0, image: "" },
    { ci: 10, image: require("../../img/cribisIndex/bw-a1.svg") },
    { ci: 9, image: require("../../img/cribisIndex/bw-a2.svg") },
    { ci: 8, image: require("../../img/cribisIndex/bw-b1.svg") },
    { ci: 7, image: require("../../img/cribisIndex/bw-b2.svg") },
    { ci: 6, image: require("../../img/cribisIndex/bw-c1.svg") },
    { ci: 5, image: require("../../img/cribisIndex/bw-c2.svg") },
    { ci: 4, image: require("../../img/cribisIndex/bw-c3.svg") },
    { ci: 3, image: require("../../img/cribisIndex/bw-d1.svg") },
    { ci: 2, image: require("../../img/cribisIndex/bw-d2.svg") },
    { ci: 1, image: require("../../img/cribisIndex/bw-e.svg") }
];

const imagesC = [
    { ci: 0, image: "" },
    { ci: 10, image: require("../../img/cribisIndex/c-a1.svg") },
    { ci: 9, image: require("../../img/cribisIndex/c-a2.svg") },
    { ci: 8, image: require("../../img/cribisIndex/c-b1.svg") },
    { ci: 7, image: require("../../img/cribisIndex/c-b2.svg") },
    { ci: 6, image: require("../../img/cribisIndex/c-c1.svg") },
    { ci: 5, image: require("../../img/cribisIndex/c-c2.svg") },
    { ci: 4, image: require("../../img/cribisIndex/c-c3.svg") },
    { ci: 3, image: require("../../img/cribisIndex/c-d1.svg") },
    { ci: 2, image: require("../../img/cribisIndex/c-d2.svg") },
    { ci: 1, image: require("../../img/cribisIndex/c-e.svg") }
];

class RatingData extends React.Component {
    state = {
        cribisIndexEvalTooltipOpen: false,
        expanded: false,
        isExpandedTouched: false,
        tooltipDetailOpen: false
    }

    get isSkCZ() { return this.props.user.authentication.profile.agentLanguage === "sk-SK" || this.props.user.authentication.profile.agentLanguage === "cs-CZ"; }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.state.expanded !== nextState.expanded || this.props.isExpandAllActivated !== nextProps.isExpandAllActivated || this.props.isHideAllActivated !== nextProps.isHideAllActivated;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderWithData(this.props.data, this.props.reportType === REPORTS.short)}</div>);
    }

    renderWithData(data, isShortReport) {
        let has10StarPermission = true;
        let images = data.cribisIndex === 0 ? imagesBw : imagesC;
        let renderStableCompanyCard = data.stableCompany || data.topStableCompany;
        let ratingCardClasses = renderStableCompanyCard ? "column is-4-desktop is-12" : "column is-6-desktop is-12";
        let line2Class = data.discipline.value || renderStableCompanyCard ? 'column is-4-desktop is-6' : 'column is-6-desktop is-12'
        let stableCompanyText = renderStableCompanyCard && data.topStableCompany ? "Rating.TopStableCompany.Description" : "Rating.StableCompany.Description";

        return (
            <div className={`${this.getBackroundColor(data.ratingTable.unavailabilityCode, data.ratingTable.tenStarRating)}`}>
                {
                    data.lastRequest !== null && data.evaluationType === 1 &&
                    <div className="rating-update-info" ><Translate id="Report.Ratings.EvalDateFin" data={{ 0: moment(data.lastRequest).format("l"), 1: moment(new Date()).format("l") }}></Translate></div>}
                {data.lastRequest !== null && data.evaluationType !== 1 &&
                    <div className="rating-update-info" ><Translate id="Report.Ratings.EvalDateNefi" data={{ 0: moment(new Date()).format("l") }} /></div>}
                {this.renderCards(data, isShortReport)}
                <div className="columns is-multiline is-centered">
                    {renderStableCompanyCard && <div className='column is-4-desktop is-12'>
                        <RatingCard white
                            title={ data.topStableCompany ? this.props.translate("Rating.TopStableCompany") : this.props.translate("Rating.StableCompany")}
                            cardType="TopStableCompany"
                        >
                            <div className="rating-badge" >
                                <img src={data.topStableCompany ? StableCompanyBadge : TopStableCompanyBadge} />
                                <span className="rating-badge-text"> <Translate id={stableCompanyText} options={{ renderInnerHtml: true }} /></span>
                            </div>

                        </RatingCard>
                    </div>}
                    <div className={line2Class}>
                        <RatingCard white
                            title={this.props.translate("Report.Ratings.IndexCribis")}
                            cardType="IndexCribis"
                            tooltip={(data.evaluationType === 1 ? this.props.translate("Report.Ratings.IndexFinDesc") : this.props.translate("Report.Ratings.IndexNefiDesc"))}
                            footer={<IndexHistory data={data.indexHistory} />} hasFooter={data.indexHistory.length > 0}>
                            <div style={{ padding: "0em 0.25em" }}>
                                <div style={{ marginBottom: "1em" }}>
                                    {data.evaluationType === 1
                                        ? <Translate id="Report.Ratings.IndexType.S1"></Translate>
                                        : <Translate id="Report.Ratings.IndexType.S0"></Translate>}
                                </div>
                                <BbPopover
                                    content={data.cribisIndex === 0 ?
                                        this.getCribisIndexDescriptionTranslation(data.cribisIndex) :
                                        (`${this.getCribisIndexTranslation(data.cribisIndex)} - ${this.getCribisIndexDescriptionTranslation(data.cribisIndex)}`)}
                                    placement="top"
                                    targetId='cribis-index-eval'
                                    toggleOnEvent="toggleOnMouse"
                                >
                                    <div id='cribis-index-eval' alt="Cribis Index" style={{ display: 'flex', justifyContent: 'center' }}>
                                        {images.map((img) => this.renderImageOfIndex(img, img.ci === data.cribisIndex))}
                                    </div>
                                </BbPopover>
                            </div>
                        </RatingCard>
                    </div>
                    <div className={line2Class}>
                        <RatingCard white bold
                            cardType="Semaphore"
                            tooltip={this.props.translate("Report.Ratings.SemaphoreDesc")}
                            title={this.props.translate("Report.Ratings.SemaphoreCribis")}
                            onFurtherInfoLinkClick={isShortReport ? this.scrollToSectionFunction(SECTIONS.shortReportWarningData) : this.scrollToSectionFunction(SECTIONS.warningData)}
                            footer={<SemaphoreHistory data={data.semaphoreHistory} />} hasFooter={data.semaphoreHistory.filter(x => x.type === "01" || x.type === "02").length > 0}>
                            <SemaphoreGroup value={data.semaphoreCode} size="large" />
                            <div style={{ alignItems: "center" }}>
                                <div className="sem-group-label"><Translate id="Report.Ratings.GroupSemaphoresCribis"></Translate></div>
                                <SemaphoreGroup value={data.groupSemaphoreCode} size="medium" />
                            </div>

                        </RatingCard>
                    </div>
                    {data.discipline.value && <div className='column is-4-desktop is-6'>
                        <RatingCard white
                            cardType="PaymentDiscipline"
                            tooltip={this.props.translate("Report.Ratings.PaymentDisciplineTooltip")}
                            title={this.props.translate("Report.Ratings.PaymentDisciplineIndex")}
                            onFurtherInfoLinkClick={isShortReport ? this.scrollToSectionFunction(SECTIONS.shortReportWarningData, '', data =>
                                (Array.isArray(data.debtActual) && data.debtActual.length > 0) ||
                                (Array.isArray(data.debtHistorical) && data.debtHistorical.length > 0))
                                : this.scrollToSectionFunction(SECTIONS.warningData, '', data =>
                                    (Array.isArray(data.debtActual) && data.debtActual.length > 0) ||
                                    (Array.isArray(data.debtHistorical) && data.debtHistorical.length > 0))
                            }
                        >
                            {data.discipline.history.length > 0 &&
                                <PaymentChart data={data.discipline.history} header={data.discipline.value} />
                            }
                        </RatingCard>
                    </div>}
                </div>
                {(data.ratingTable.risk || (data.financial && data.financial.fRows.length > 0)) && <>
                    <div className="history-link-box">
                        <span className="link-functional" onClick={() => this.expand()}>
                            {this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)
                                ? <Translate id="Common.LessInformation" /> : <Translate id="Common.MoreInformation" />}
                        </span>
                    </div>
                    <Collapse isOpen={this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched)}>
                        <br />
                        <div className="columns is-multiline is-desktop is-centered">
                            {data.ratingTable.risk &&
                                <div className="column is-6-widescreen is-12">
                                    <RatingCard white aligned title={this.props.translate("Report.Ratings.Risk")} alignTop>
                                        <RatingTable data={data.ratingTable} desc={data.desc} has10StarPermission={has10StarPermission} />
                                    </RatingCard>
                                </div>
                            }
                            {data.financial && data.financial.fRows.length > 0 &&
                                <div className="column is-6-widescreen is-12">
                                    <RatingCard white aligned
                                        cardType="SelectedFinancialRatios"
                                        tooltip={this.props.translate("Report.Ratings.Explanatory.SelectedFinancialRatiosDesc")}
                                        title={this.props.translate("Report.Ratings.SelectedFinancialRatios")}
                                    >
                                        <FinStatement data={data.financial}></FinStatement>
                                    </RatingCard>
                                </div>
                            }
                        </div>
                    </Collapse>
                </>}
                {data.ratingTable.unavailabilityCode === "NG" &&
                    <div style={{ textAlign: "right", width: "100%", color: (data.cribisIndex != null && data.cribisIndex > 0 ? "red" : "black") }}>
                        {data.ratingTable.unavailabilityDesc}
                        <span className='delimiter-0-25em' />
                        <span onClick={this.scrollToSectionFunction(SECTIONS.finStatementsData)}>
                            <MarkIcon id={`detail-tooltip-unavailability`} style={{ cursor: 'pointer', height: "1em" }} />
                            <Tooltip
                                placement="left" target={`detail-tooltip-unavailability`}
                                isOpen={this.state.tooltipDetailOpen}
                                toggle={() => this.setState({ tooltipDetailOpen: !this.state.tooltipDetailOpen })}
                                innerClassName='bb-tooltip-inner'
                            >
                                {this.state.tooltipDetailOpen ? this.props.translate("Common.LessInformation") : this.props.translate("Common.MoreInformation")}
                            </Tooltip>
                        </span>
                    </div>
                }
            </div>
        )
    }

    renderCards = (data, isShortReport) => {
        const fixedCardClass = (data.iTrade.isAvailable && !data.monitora.isAvailable) || (!data.iTrade.isAvailable && data.monitora.isAvailable)
            ? "column is-3-widescreen is-6" : "column is-4-widescreen is-6";

        return (
            <div className="columns cards-fixed-height is-multiline is-centered">
                <div className={fixedCardClass}>
                    <RatingCard
                        cardType='CreditCapacity'
                        tooltip={data.country === "SK" ? this.props.translate("Report.Ratings.CreditCapacityDescSK") : this.props.translate("Report.Ratings.CreditCapacityDescCZ")}
                        title={this.props.translate(data.country === "SK" ? "Report.Ratings.CreditCapacitySK" : "Report.Ratings.CreditCapacity", { val: data.currency === "CZK" ? "tis." : "", currency: data.currency })}
                    >
                        {data.creditCapacity.includes('-') && <div style={{ fontSize: "1.2em", fontWeight: "600" }}>{data.creditCapacity}</div>}
                        {!data.creditCapacity.includes('-') && <div style={{ fontSize: "2em", fontWeight: "600" }}>{data.creditCapacity}</div>}
                    </RatingCard>
                </div>
                <div className={fixedCardClass}>
                    <RatingCard
                        cardType="PossibleCredit"
                        title={this.props.translate(data.country === "SK" ? "Report.Ratings.PossibleCreditAccrualSK" : "Report.Ratings.PossibleCreditAccrual",
                            { val: data.currency === "CZK" ? "tis." : "", currency: data.currency })}
                        tooltip={data.country === "SK" ? this.props.translate("Report.Ratings.CreditAccrualDescSK") : this.props.translate("Report.Ratings.CreditAccrualDescCZ")}
                    >
                        {data.shortCreditCapacity.includes('-') && <div style={{ fontSize: "1.2em", fontWeight: "600" }}>{data.shortCreditCapacity}</div>}
                        {!data.shortCreditCapacity.includes('-') && <div style={{ fontSize: "2em", fontWeight: "600" }}>{data.shortCreditCapacity}</div>}
                    </RatingCard>
                </div>
                <div className={fixedCardClass}>
                    <RatingCard
                        cardType="ProbabilityOfDefault"
                        title={this.props.translate("Report.Ratings.ProbabilityOfDefault")}
                        tooltip={this.props.translate("Report.Ratings.BankruptcyDesc")}
                    >
                        <div style={{ fontSize: "2em", fontWeight: "600", color: isNullOrUndefined(data.default.value) ? "inherit" : getColor(data.default.value, data.default.min, data.default.mid, data.default.max) }}>
                            {data.default.value || "N/A"}
                        </div>
                    </RatingCard>
                </div>
                {this.renderITradeCard(data, isShortReport, fixedCardClass)}
                {data.monitora.isAvailable && <div className={fixedCardClass}>
                    <RatingCard
                        cardType="Monitora"
                        title={this.props.translate("Report.Quick.MonitoraTeaser.TotalTitle")}
                        tooltip={this.props.translate("Report.Monitora.Help")}
                        onFurtherInfoLinkClick={!isShortReport && this.scrollToSectionFunction(SECTIONS.monitoraTeaser)}
                    >
                        <div style={{ fontSize: "2em", fontWeight: "600" }}>
                            <span>{data.monitora.messages}</span>
                        </div>
                        <span><Translate id='Report.Quick.MonitoraTeaser.DaysTitle' /> {data.monitora.days}  <Translate id='Report.Quick.MonitoraTeaser.Days' /></span>
                    </RatingCard>
                </div>}
            </div>
        );
    }

    renderITradeCard = (data, isShortReport, fixedCardClass) => {
        // onlyInRepi = null means that user doesn't have iTrade roles nor is Repi member
        if (isNullOrUndefined(data.iTrade) || !data.iTrade.isAvailable || data.iTrade.onlyInRepi === null)
            return null;

        // onlyInRepi = false means that user have iTrade roles, iTrade roles are superior to Repi roles
        if (data.iTrade.onlyInRepi === false) {
            return (
                <div className={fixedCardClass}>
                    <RatingCard cardType="ITrade"
                        title={this.props.translate("Report.Ratings.ITradeIndex")}
                        tooltip={this.props.translate("Report.Ratings.ITradeTooltip")}
                        onFurtherInfoLinkClick={isShortReport ? this.scrollToSectionFunction(SECTIONS.shortReportITrade) : this.scrollToSectionFunction(SECTIONS.iTrade)}
                    >
                        <div style={{
                            color: getColor(data.iTrade.index, data.iTrade.indexes.index0, data.iTrade.indexes.index1, data.iTrade.indexes.index2),
                            fontSize: "2em", fontWeight: "600"
                        }}>
                            {data.iTrade.index}
                        </div>
                        <div>
                            <Translate id="Report.Itrade.AvgSectorTradeIndex"></Translate>:
                            <span style={{
                                color: getColor(data.iTrade.avgIndex, data.iTrade.indexes.index0, data.iTrade.indexes.index1, data.iTrade.indexes.index2),
                                fontSize: "1em",
                                fontWeight: "bold"
                            }}>
                                &nbsp;{data.iTrade.avgIndex}
                            </span>
                        </div>
                    </RatingCard>
                </div>
            );
        }

        if (!hasPermission(null, "REPIiTradeBanner"))
            return null;

        if (!data.isCompany || data.isFop)
            return null;

        const isRepiMember = data.iTrade.onlyInRepi === true;
        const hasAccess = data.isCompany && !data.isFop && hasPermission(null, "REPIPO");

        const shared = getRepiSetting("allowSharing", false);
        let iTradeUrl = this.isSkCZ ? "https://www.mcribis.cz/sluzby/repi/" : "https://www.mcribis.cz/en/services/repi/";
        const repiLang = this.props.user.authentication.profile.agentLanguage === "sk-SK" ? "Sk" : "";

        if (isRepiMember && hasAccess) {
            if (hasPermission(null, `REPI${repiLang}CreditReportInvoicesPlus`))
                iTradeUrl = `/repi/report/InvoicesPlus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
            else if (hasPermission(null, `REPI${repiLang}CreditReportInvoicesMinus`))
                iTradeUrl = `/repi/report/InvoicesMinus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
            else if (hasPermission(null, `REPI${repiLang}CreditReportPlus`) && hasPermission(null, "REPIItrade"))
                iTradeUrl = `/repi/report/CreditPlus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
            else if (hasPermission(null, `REPI${repiLang}CreditReportMinus`) && hasPermission(null, "REPIItrade"))
                iTradeUrl = `/repi/report/CreditMinus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
            else if (hasPermission(null, `REPI${repiLang}CreditReportPoolPlus`) && hasPermission(null, "REPIItrade"))
                iTradeUrl = `/repi/report/PoolPlus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
            else if (hasPermission(null, `REPI${repiLang}CreditReportPoolMinus`) && hasPermission(null, "REPIItrade"))
                iTradeUrl = `/repi/report/PoolMinus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
            else if (hasPermission(null, `REPI${repiLang}CreditReportPlusSubject`) && hasPermission(null, "REPIItrade"))
                iTradeUrl = `/repi/report/SubjectPlus/${this.props.id}?sharedRegistry=${shared}&source=cribis`;
        }

        const urlChanged = isString(iTradeUrl) &&
            iTradeUrl !== "https://www.mcribis.cz/sluzby/repi/" && iTradeUrl !== "https://www.mcribis.cz/en/services/repi/";

        return (
            <div className={fixedCardClass}>
                <RatingCard cardType="ITrade"
                    title={this.props.translate("Report.Ratings.ITradeTitleRepi")}
                    tooltip={this.props.translate("Report.Ratings.ITradeTooltipRepi")}
                    onFurtherInfoLinkClick={isRepiMember && hasAccess && urlChanged
                        ? () => redirectToRepi(iTradeUrl, false, this.props)
                        : () => window.open(iTradeUrl, "_blank")}
                >
                    <div style={{
                        color: getColor(data.iTrade.index, data.iTrade.indexes.index0, data.iTrade.indexes.index1, data.iTrade.indexes.index2),
                        fontSize: "2em", fontWeight: "600"
                    }}>
                        {data.iTrade.index}
                    </div>
                    <div>
                        <Translate id="Report.Itrade.AvgSectorTradeIndexRepi"></Translate>:
                        <span style={{
                            color: getColor(data.iTrade.avgIndex, data.iTrade.indexes.index0, data.iTrade.indexes.index1, data.iTrade.indexes.index2),
                            fontSize: "1em",
                            fontWeight: "bold"
                        }}>
                            &nbsp;{data.iTrade.avgIndex}
                        </span>
                    </div>
                </RatingCard>
            </div>
        );
    }

    renderImageOfIndex = (image, large) => {
        if (image.ci === 0)
            return "";

        let className = large ? "index-cribis-large-item" : "index-cribis-item";

        return (<img src={image.image} key={image.ci} className={className}></img>)
    }

    getColor(sCode) {
        if (sCode === "01")
            return "#76933C";
        if (sCode === "02")
            return "#FFCC00";
        if (sCode === "03")
            return "#FF0000";
    }
    getBackroundColor(uCode, tenStar) {
        if (uCode === "NG" && tenStar) {
            return "alert alert-danger";
        }
        return "";
    }

    getCapacity(country, obj) {
        if (obj.low === null || obj.high === null) {
            return <div style={{ fontSize: "2em", fontWeight: "600", }}>N/A</div>;
        }

        if (obj.low === obj.high) {
            return <div style={{ fontSize: "2em", fontWeight: "600", }}>{obj.low}</div>
        } else {
            return <div style={{ fontSize: "1.5em" }}>{obj.low} - {obj.high}</div>
        }
    }

    scrollToSectionFunction = (topSection, simpleSection, sectionHasData) => {
        const section = this.props.report.sections.find(i => i.id === topSection);
        if (section && section.hidden) {
            return null;
        }

        return _ => ((section, simpleSection, sectionHasData) => {
            if (section) {
                if (!section.hidden) {
                    this.props.scrollToSection(section, simpleSection, sectionHasData);
                }
            } else {
                this.props.showPopup('informationMessagePopup', { open: true, close: () => this.props.hidePopup(), message: this.props.translate("UnhappyUser.NotAllowedAction") });
            }
        })(section, simpleSection, sectionHasData);
    }

    getCribisIndexDescriptionTranslation = cribisIndex => this.props.translate(`Report.Ratings.CribisIndexTooltip${cribisIndex}`);

    getCribisIndexTranslation = cribisIndex => this.props.translate(`Report.Ratings.10Star.${cribisIndex}`);

    expand() {
        this.setState({
            expanded: !this.props.resolveExpanded(this.state.expanded, this.state.isExpandedTouched),
            isExpandedTouched: true
        });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ report: state.report, user: state.userContext }),
    dispatch => bindActionCreators(({ ...reportActions, ...popupActions }), dispatch)
)(RatingData)));

